import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';
import type { JPDExperience } from '../../utils/experience/types.tsx';

export const issueTypesForProjectsLoad: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.issue-types.load-all', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const issueTypeCreate = createJpdExperience(
	new UFOExperience('jpd.issue-types.create', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const issueTypeDelete = createJpdExperience(
	new UFOExperience('jpd.issue-types.delete', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const issueTypeUpdate = createJpdExperience(
	new UFOExperience('jpd.issue-types.update', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const issueTypePinnedFieldsUpdate = createJpdExperience(
	new UFOExperience('jpd.issue-types.pinned-fields.update', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
